module.exports = " <div v-if=show class=showbanner _v-243d033a=\"\"> <p class=text-right _v-243d033a=\"\"> <a @click=close style=cursor:pointer _v-243d033a=\"\"><span class=\"glyphicon glyphicon-remove-circle\" _v-243d033a=\"\"></span></a> </p> <h3 _v-243d033a=\"\"><strong _v-243d033a=\"\">{{banner.Type}}</strong></h3> <p _v-243d033a=\"\"> {{banner.Description}} </p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-243d033a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Common/banner.vue
// module id = 663
// module chunks = 0